import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormInputCalendarComponent} from './form-input-calendar.component';
import {CalendarModule} from 'primeng/calendar';
import {SharedModule} from '../../../modules/shared/shared.module';
import {FormInputErrorModule} from '../form-input-error/form-input-error.module';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    FormInputCalendarComponent
  ],
  imports: [
    CommonModule,
    CalendarModule,
    SharedModule,
    FormInputErrorModule,
    FormsModule
  ],
  exports: [
    FormInputCalendarComponent
  ]
})
export class FormInputCalendarModule {
}
